<section>

    <div class="flex justify-between items-end">
        <div>
          <h1>Courses</h1>
        </div>

      </div>

      <!-- courses -->
       <div class="grid grid-cols-1 gap-5 mt-5">

        @for (i of [1,2,3]; track $index) {
          <app-teacher-course-play-list></app-teacher-course-play-list>
        }

       </div>
      <!-- courses -->

      <hr class="my-5">

      <div class="">
        <h2 class="font-semibold underline">Self Learning</h2>

        <div class="grid grid-cols-4 gap-5 mt-5">

          @for (i of data; track $index) {
          <div class="bg-white border rounded-lg p-5">
            <a  >
              <img src="{{i.img}}" class="bg-slate-200 w-full h-[10rem] rounded-lg object-cover" alt="">
              <div class="mt-2">
                <h2 class="font-semibold line-clamp-2">{{i.title}}</h2>
                <span class="text-xs text-zinc-500">{{i.type}}</span>
              </div>
            </a>
          </div>
          }
      
        </div>


      </div>




</section>